// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconLock = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 16 16' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M8 3c1.118 0 2.024.932 2.024 2.083v1.25H5.976v-1.25C5.976 3.933 6.882 3 8 3M4.357 5.083v1.25h-.405c-.893 0-1.619.748-1.619 1.667v5c0 .92.726 1.667 1.62 1.667h8.094c.893 0 1.62-.748 1.62-1.667V8c0-.92-.727-1.667-1.62-1.667h-.405v-1.25c0-2.07-1.631-3.75-3.642-3.75s-3.643 1.68-3.643 3.75m4.452 4.584v1.666a.82.82 0 0 1-.81.834.82.82 0 0 1-.809-.834V9.667A.82.82 0 0 1 8 8.833a.82.82 0 0 1 .81.834'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconLock)
const Memo = memo(ForwardRef)
export default Memo
